import {
  FETCH_EVENT_REQUEST,
  FETCH_EVENT_REQUEST_START,
  FETCH_EVENT_REQUEST_UNREAD_MESSAGES,
  FETCH_EVENT_REQUEST_ERROR,
  RESET_EVENT_REQUEST,
} from '../constants/action-types';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_EVENT_REQUEST_START:
      return { loading: true };
    case FETCH_EVENT_REQUEST:
      return { ...state, ...action.payload, loading: false };
    case FETCH_EVENT_REQUEST_UNREAD_MESSAGES:
      return {
        ...state,
        unreadQuotes: action.payload,
      };
    case FETCH_EVENT_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.status,
      };
    case RESET_EVENT_REQUEST:
      return {};
    default:
      return state;
  }
}
